<template>
    <layout title="Inicio">
        <div class="heroblock" style="background-image: url('images/papeleria_ill2.jpg');">
            <p class="heroblock-subttl"><inertia-link href="/productos">Papelería</inertia-link></p>
            <h3 class="heroblock-ttl">Suministros de Papelería y Computación</h3>
            <inertia-link :href="`/productos`" class="relative z-20 px-8 py-4 cursor-pointer font-semibold shadow text-white bg-green-600 hover:bg-green-500 transition-colors duration-300">Ver catálogo</inertia-link>
        </div>

        <div class="container mb60 page-styling row-wrap-container row-wrap-nottl">
            <p class="maincont-subttl">Ofertas especiales</p>
            <h2 class="mb35 heading-multishop">Nuestros productos</h2>
            <div class="row prod-items prod-items-3">
                <article v-for="product in _featuredProducts" :key="product.id" class="cf-sm-6 cf-md-4 cf-lg-4 col-xs-6 col-sm-6 col-md-4 col-lg-4 sectgl-item">
                    <div class="sectgl prod-i">
                        <div class="prod-i-top">
                            <inertia-link class="prod-i-img" :href="`/productos/${product.slug}`">
                                <img v-if="product.images && product.images.length" :src="`/storage/${product.images[0]}`">
                            </inertia-link>

                            <!-- <p class="prod-i-badge"><span class="badge-1">Top seller</span></p> -->
                            <!-- <p class="prod-i-badge"><span>Sale</span></p> -->
                        </div>
                        <div class="prod-i-bot">
                            <div class="prod-i-info">
                                <p class="prod-i-price"><!--<del>$15.00</del>-->${{ product.price }}</p>
                                <p class="prod-i-categ"><inertia-link :href="`/categorias/${product.category.slug}`">{{ product.category.name }}</inertia-link></p>
                            </div>
                            <h3 class="prod-i-ttl"><inertia-link :href="`/productos/${product.slug}`">{{ product.name }}</inertia-link></h3>
                        </div>
                    </div>
                </article>
            </div>
            <p class="special-more">
                <inertia-link class="special-more-btn" href="/productos">Ver más productos</inertia-link>
            </p>
        </div>
    </layout>
</template>

<script>
import Layout from './Layout';

export default {
    components: {
        Layout,
    },
    props: {
        _featuredProducts: Array,
    },
}
</script>

<style>

</style>
